/**
 * 小红书爆款 - 快速冲击模板 Compositions
 *
 * 包含：技能速成、知识盘点、技巧合集等快节奏模板
 */

import { Composition } from 'remotion';
import { XHSFastImpact } from './XHSFastImpact';

const skillQuickStartExample = {
  hookTexts: ['3天', '速成', '技能!'],
  infoItems: [
    {
      number: '1',
      title: 'Day 1：搭建知识框架',
      content: '梳理核心概念，建立学习路线图',
      color: '#FF006E',
    },
    {
      number: '2',
      title: 'Day 2：刻意练习',
      content: '动手做项目，把理论变成肌肉记忆',
      color: '#00F5FF',
    },
    {
      number: '3',
      title: 'Day 3：攻克难点',
      content: '逐个击破高频错误，巩固薄弱环节',
      color: '#FFE942',
    },
    {
      number: '4',
      title: 'Day 4：实战输出',
      content: '独立完成真实场景任务，检验学习成果',
      color: '#39FF14',
    },
    {
      number: '5',
      title: 'Day 5：复盘迭代',
      content: '总结方法论，形成可复用的技能体系',
      color: '#BF00FF',
    },
  ],
  summary: '快速成长！',
  ctaText: '点赞关注，一起学',
  sceneTitle: '⚡ 5 天速成计划',
};

export const XHSFastImpactCompositions = () => {
  return (
    <>
      <Composition
        id="XHS-Viral-SkillQuickStart"
        component={XHSFastImpact}
        durationInFrames={600}
        fps={30}
        width={1080}
        height={1920}
        defaultProps={skillQuickStartExample}
      />
    </>
  );
};
